import { lazy, Suspense, useCallback, useEffect } from "react";
import { Hud } from "./components/Hud";
import { StorySections } from "./components/StorySections";
import { useScrollTimeline } from "./hooks/use-scroll-timeline";
import { useShowroomControls } from "./hooks/use-showroom-controls";
import { useExperienceStore } from "./store/experience-store";

const ExhibitionScene = lazy(async () => {
  const module = await import("./components/scene/ExhibitionScene");
  return { default: module.ExhibitionScene };
});

export function App(): React.JSX.Element {
  const focusedProductIndex = useExperienceStore(
    (store) => store.focusedProductIndex,
  );
  const { cancelProgrammaticScroll, scrollToChapter, scrollToEnd } =
    useScrollTimeline();
  const handleChapterSelect = useCallback(
    (index: number): void => {
      cancelProgrammaticScroll();
      scrollToChapter(index, true);
    },
    [cancelProgrammaticScroll, scrollToChapter],
  );
  useShowroomControls({
    cancelProgrammaticScroll,
    scrollToChapter,
    scrollToEnd,
  });

  useEffect(() => {
    document.documentElement.dataset.runtime = window.showroom?.runtime ?? "browser";
  }, []);

  return (
    <div
      className="experience-shell"
      data-product-focus={focusedProductIndex ?? "none"}
    >
      <a className="skip-link" href="#story">
        跳到展厅内容
      </a>
      <Suspense fallback={<div className="scene-loading" aria-hidden="true" />}>
        <ExhibitionScene />
      </Suspense>
      <Hud onChapterSelect={handleChapterSelect} />
      <StorySections />
    </div>
  );
}
